export const RoadMeasuresProfileColumns: any = [
    {
        headerName: "Уклон в начале, ‰",
        pdfHeader: "Уклон в начале, ‰",
        field: "StartSlope",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уклон в начале, ‰ =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Уклон в конце, ‰",
        pdfHeader: "Уклон в конце, ‰",
        field: "EndSlope",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уклон в конце, ‰ =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Уклон, ‰",
        pdfHeader: "Уклон, ‰",
        field: "Slope",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уклон, ‰ =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Радиус, м",
        pdfHeader: "Радиус, м",
        field: "Radius",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Радиус, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Длина участка, км",
        pdfHeader: "Длина участка, км",
        field: "Length",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Длина участка, км =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

export const RoadMeasuresLongitudinalSlopesColumns: any = [
    {
        headerName: "Уклон в начале, ‰",
        pdfHeader: "Уклон в начале, ‰",
        field: "StartSlope",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уклон в начале, ‰ =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Уклон в конце, ‰",
        pdfHeader: "Уклон в конце, ‰",
        field: "EndSlope",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уклон в конце, ‰ =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Уклон, ‰",
        pdfHeader: "Уклон, ‰",
        field: "Slope",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уклон, ‰ =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Радиус, м",
        pdfHeader: "Радиус, м",
        field: "Radius",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Радиус, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

export const RoadMeasuresCurveRadiusColumns: any = [
    {
        headerName: "Радиус, м",
        pdfHeader: "Радиус, м",
        field: "Value",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Радиус, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    // {
    //     headerName: "Длина участка, км",
    //     pdfHeader: "Длина участка, км",
    //     field: "Length",
    //     valueType: "float",
    //     canBeFiltered: true,
    //     filterType: "equals",
    //     filterPlaceholder: "Длина участка, км =",
    //     canBeSorted: true,
    //     showFilterMenu: true,
    //     width: 200,
    //     align: "left"
    // },
    {
        headerName: "Угол поворота, °",
        pdfHeader: "Угол поворота, °",
        field: "Angle",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Угол поворота, ° =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Азимут в начале, °",
        pdfHeader: "Азимут в начале, °",
        field: "Azimuth",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Азимут в начале, ° =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

export const RoadMeasuresVisibilityColumns: any = [
    {
        headerName: "В прямом направлении в профиле, м",
        pdfHeader: "В прямом направлении в профиле, м",
        field: "ForwardDirectionValue",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "В прямом направлении в профиле, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "В обратном направлении в профиле, м",
        pdfHeader: "В обратном направлении в профиле, м",
        field: "ReverseDirectionValue",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "В обратном направлении в профиле, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "В прямом направлении в плане, м",
        pdfHeader: "В прямом направлении в плане, м",
        field: "ForwardDirectionValuePlan",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "В прямом направлении в плане, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "В обратном направлении в плане, м",
        pdfHeader: "В обратном направлении в плане, м",
        field: "ReverseDirectionValuePlan",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "В обратном направлении в плане, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Длина участка, км",
        pdfHeader: "Длина участка, км",
        field: "Length",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Длина участка, км =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Причина ограничения видимости",
        pdfHeader: "Причина ограничения видимости",
        field: "Reason",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Причина ограничения видимости =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

export const RoadMeasuresLightingsColumns: any = [
    {
        headerName: "Конец, км",
        pdfHeader: "Конец, км",
        field: "Ending",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Конец, км =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Средняя яркость, кд/м²",
        pdfHeader: "Средняя яркость, кд/м²",
        field: "AverageBrightness",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Средняя яркость, кд/м² =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Общая равномерность яркости",
        pdfHeader: "Общая равномерность яркости",
        field: "TotalBrightnessUniformity",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Общая равномерность яркости =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Продольная равномерность яркости",
        pdfHeader: "Продольная равномерность яркости",
        field: "AxialBrightnessUniformity",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Продольная равномерность яркости =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Пороговое приращение яркости, %",
        pdfHeader: "Пороговое приращение яркости, %",
        field: "MaxBrightnessIncrement",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Пороговое приращение яркости, % =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Средняя освещённость, лк",
        pdfHeader: "Средняя освещённость, лк",
        field: "AverageLighting",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Средняя освещённость, лк =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Равномерность освещённости",
        pdfHeader: "Равномерность освещённости",
        field: "LightingUniformity",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Равномерность освещённости =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Коэффициент периферийного освещения",
        pdfHeader: "Коэффициент периферийного освещения",
        field: "PeripheralLightingRatio",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Коэффициент периферийного освещения =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Макс. относительная удельная мощность, МВт/(м²*лк)",
        pdfHeader: "Макс. относительная удельная мощность, МВт/(м²*лк)",
        field: "MaxRelativePower",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Макс. относительная удельная мощность, МВт/(м²*лк) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

export const RoadMeasuresRoadbedComplexsColumns: any = [
    {
        headerName: "Уширение слева, м (обратное направление)",
        pdfHeader: "Уширение слева, м (обратное направление)",
        field: "BackwardLeftAccelLine",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уширение слева, м (обратное направление) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Ширина ПЧ, м (асфальтобетон, обратное направление)",
        pdfHeader: "Ширина ПЧ, м (асфальтобетон, обратное направление)",
        field: "BackwardDriveway",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Ширина ПЧ, м (асфальтобетон, обратное направление) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Уширение справа, м (обратное направление)",
        pdfHeader: "Уширение справа, м (обратное направление)",
        field: "BackwardRightAccelLine",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уширение справа, м (обратное направление) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Разделительная полоса",
        pdfHeader: "Разделительная полоса",
        field: "DemarcationStrip",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Разделительная полоса =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Уширение слева, м (обратное направление)",
        pdfHeader: "Уширение слева, м (обратное направление)",
        field: "BackwardLeftAccelLine",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уширение слева, м (обратное направление) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Ширина ПЧ, м (асфальтобетон, обратное направление)",
        pdfHeader: "Ширина ПЧ, м (асфальтобетон, обратное направление)",
        field: "BackwardDriveway",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Ширина ПЧ, м (асфальтобетон, обратное направление) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Уширение справа, м (обратное направление)",
        pdfHeader: "Уширение справа, м (обратное направление)",
        field: "BackwardRightAccelLine",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уширение справа, м (обратное направление) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Разделительная полоса",
        pdfHeader: "Разделительная полоса",
        field: "DemarcationStrip",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Разделительная полоса =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },

]

export const RoadMeasureRoadbedsColumns: any = [
    {
        headerName: "Высота левого откоса, м",
        pdfHeader: "Высота левого откоса, м",
        field: "LeftSlopeHeight",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Высота левого откоса, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "К-т заложения левого откоса (1:*)",
        pdfHeader: "К-т заложения левого откоса (1:*)",
        field: "LeftSlopeRatio",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "К-т заложения левого откоса (1:*) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Засев трав (левая обочина)",
        pdfHeader: "Засев трав (левая обочина)",
        field: "LeftEdgeGrass",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Засев трав (левая обочина) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Щебень (левая обочина)",
        pdfHeader: "Щебень (левая обочина)",
        field: "LeftEdgeBreakstone",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Щебень (левая обочина) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Асфальтобетон (левая обочина)",
        pdfHeader: "Асфальтобетон (левая обочина)",
        field: "LeftEdgeAsphalt",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Асфальтобетон (левая обочина) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Уширение слева, м",
        pdfHeader: "Уширение слева, м",
        field: "LeftAccelLine",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уширение слева, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Ширина ПЧ, м (асфальтобетон)",
        pdfHeader: "Ширина ПЧ, м (асфальтобетон)",
        field: "Driveway",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Ширина ПЧ, м (асфальтобетон) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Уширение справа, м",
        pdfHeader: "Уширение справа, м",
        field: "RightAccelLine",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Уширение справа, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Асфальтобетон (правая обочина)",
        pdfHeader: "Асфальтобетон (правая обочина)",
        field: "RightEdgeAsphalt",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Асфальтобетон (правая обочина) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Щебень (правая обочина)",
        pdfHeader: "Щебень (правая обочина)",
        field: "RightEdgeBreakstone",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Щебень (правая обочина) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Засев трав (правая обочина)",
        pdfHeader: "Засев трав (правая обочина)",
        field: "RightEdgeGrass",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Засев трав (правая обочина) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Высота правого откоса, м",
        pdfHeader: "Высота правого откоса, м",
        field: "RightSlopeHeight",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Высота правого откоса, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "К-т заложения правого откоса (1:*)",
        pdfHeader: "К-т заложения правого откоса (1:*)",
        field: "RightSlopeRatio",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "К-т заложения правого откоса (1:*) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

// export const RoadMeasureTransverseSlopeSegmentsColumns: any = [
//     {
//         headerName: "Наличие виража (кривой малого радиуса)",
//         pdfHeader: "Наличие виража (кривой малого радиуса)",
//         field: "TurnPresence",
//         valueType: "float",
//         canBeFiltered: true,
//         filterType: "equals",
//         filterPlaceholder: "Наличие виража (кривой малого радиуса) =",
//         canBeSorted: true,
//         showFilterMenu: true,
//         width: 100,
//         align: "left"
//     },
//     {
//         headerName: "Тип поперечного профиля проезжей части",
//         pdfHeader: "Тип поперечного профиля проезжей части",
//         field: "SectionType",
//         valueType: "float",
//         canBeFiltered: true,
//         filterType: "equals",
//         filterPlaceholder: "Тип поперечного профиля проезжей части =",
//         canBeSorted: true,
//         showFilterMenu: true,
//         width: 200,
//         align: "left"
//     },
//     {
//         headerName: "Нормативное значение уклона (1 и 2 полосы от разделительной)",
//         pdfHeader: "Нормативное значение уклона (1 и 2 полосы от разделительной)",
//         field: "AdmissibleValue",
//         valueType: "float",
//         canBeFiltered: true,
//         filterType: "equals",
//         filterPlaceholder: "Нормативное значение уклона (1 и 2 полосы от разделительной) =",
//         canBeSorted: true,
//         showFilterMenu: true,
//         width: 200,
//         align: "left"
//     },
//     {
//         headerName: "Нормативное значение уклона (3 и последующие полосы от разделительной)",
//         pdfHeader: "Нормативное значение уклона (3 и последующие полосы от разделительной)",
//         field: "AdmissibleValueAdditional",
//         valueType: "float",
//         canBeFiltered: true,
//         filterType: "equals",
//         filterPlaceholder: "Разделительная полоса =",
//         canBeSorted: true,
//         showFilterMenu: true,
//         width: 200,
//         align: "left"
//     },
//     {
//         headerName: "Минимальное нормативное значение уклона на вираже",
//         pdfHeader: "Минимальное нормативное значение уклона на вираже",
//         field: "MinAdmissibleValueOnTurn",
//         valueType: "float",
//         canBeFiltered: true,
//         filterType: "equals",
//         filterPlaceholder: "Минимальное нормативное значение уклона на вираже =",
//         canBeSorted: true,
//         showFilterMenu: true,
//         width: 200,
//         align: "left"
//     },
//     {
//         headerName: "Максимальное нормативное значение уклона на вираже",
//         pdfHeader: "Максимальное нормативное значение уклона на вираже",
//         field: "MaxAdmissibleValueOnTurn",
//         valueType: "float",
//         canBeFiltered: true,
//         filterType: "equals",
//         filterPlaceholder: "Максимальное нормативное значение уклона на вираже =",
//         canBeSorted: true,
//         showFilterMenu: true,
//         width: 200,
//         align: "left"
//     },
//     {
//         headerName: "Дорожная одежда капитального типа",
//         pdfHeader: "Дорожная одежда капитального типа",
//         field: "FundamentalPavement",
//         valueType: "float",
//         canBeFiltered: true,
//         filterType: "equals",
//         filterPlaceholder: "Дорожная одежда капитального типа =",
//         canBeSorted: true,
//         showFilterMenu: true,
//         width: 200,
//         align: "left"
//     },
// ]

export const RoadMeasuresAutomaticTrafficIntensityColumns: any = [
    {
        headerName: "Количество легковых автомобилей",
        pdfHeader: "Количество легковых автомобилей",
        field: "PassengerCar",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество легковых автомобилей =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Количество автобусов",
        pdfHeader: "Количество автобусов",
        field: "Bus",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество автобусов =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество лёгких грузовых (до 5 т)",
        pdfHeader: "Количество лёгких грузовых (до 5 т)",
        field: "LightDutyTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество лёгких грузовых (до 5 т) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество средних грузовых  (от 5 до 12 т)",
        pdfHeader: "Количество средних грузовых  (от 5 до 12 т)",
        field: "MediumDutyTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество средних грузовых  (от 5 до 12 т) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество тяжёлых грузовых (от 12 до 20 т)",
        pdfHeader: "Количество тяжёлых грузовых (от 12 до 20 т)",
        field: "HeavyDutyTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество тяжёлых грузовых (от 12 до 20 т) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество сверхтяжёлых грузовых (свыше 20 т)",
        pdfHeader: "Количество сверхтяжёлых грузовых (свыше 20 т)",
        field: "SuperHeavyDutyTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество сверхтяжёлых грузовых (свыше 20 т) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Актуально с, км",
        pdfHeader: "Актуально с, км",
        field: "RelevantFrom",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Актуально с, км =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Актуально по, км",
        pdfHeader: "Актуально по, км",
        field: "RelevantTo",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Актуально по, км =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество нераспознанных",
        pdfHeader: "Количество нераспознанных",
        field: "Undetermined",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество нераспознанных =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

export const RoadMeasuresDurtyingWidthColumns: any = [
    {
        headerName: "Значение в прямом направлении, м",
        pdfHeader: "Значение в прямом направлении, м",
        field: "ForwardDirectionValue",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Значение в прямом направлении, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Значение в обратном направлении, м",
        pdfHeader: "Значение в обратном направлении, м",
        field: "ReverseDirectionValue",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Значение в обратном направлении, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    }
]

export const RoadMeasuresElevationColumns: any = [
    {
        headerName: "Высота, м",
        pdfHeader: "Высота, м",
        field: "Value",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Высота, м =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    }
]

export const RoadMeasuresScanColumns: any = [
    {
        headerName: "Широта центра сканирования",
        pdfHeader: "Широта центра сканирования",
        field: "Parallel",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Широта центра сканирования =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Долгота центра сканирования",
        pdfHeader: "Долгота центра сканирования",
        field: "Meridian",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Долгота центра сканирования =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Высота над эллипсоидом центра сканирования",
        pdfHeader: "Высота над эллипсоидом центра сканирования",
        field: "Height",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Высота над эллипсоидом центра сканирования =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Курсовой угол",
        pdfHeader: "Курсовой угол",
        field: "RelativeBearing",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Курсовой угол =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Крен сканера",
        pdfHeader: "Крен сканера",
        field: "Heel",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Крен сканера =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Тангаж",
        pdfHeader: "Тангаж",
        field: "Pitch",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Тангаж =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Линейное положение относительно центра сканирования",
        pdfHeader: "Линейное положение относительно центра сканирования",
        field: "ScanOffset",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Линейное положение относительно центра сканирования =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

export const RoadMeasuresTrafficIntensityColumns: any = [
    {
        headerName: "Количество мотоциклов и мопедов",
        pdfHeader: "Количество мотоциклов и мопедов",
        field: "Motorcycle",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество мотоциклов и мопедов =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Количество легковых автомобилей",
        pdfHeader: "Количество легковых автомобилей",
        field: "PassengerCar",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество легковых автомобилей =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество автобусов",
        pdfHeader: "Количество автобусов",
        field: "Bus",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество автобусов =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество лёгких грузовых",
        pdfHeader: "Количество лёгких грузовых",
        field: "LightDutyTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество лёгких грузовых =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество средних грузовых",
        pdfHeader: "Количество средних грузовых",
        field: "MediumDutyTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество средних грузовых =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество средних грузовых автопоездов",
        pdfHeader: "Количество средних грузовых автопоездов",
        field: "MediumDutyTruckRoadTrain",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество средних грузовых автопоездов =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество тяжёлых грузовых",
        pdfHeader: "Количество тяжёлых грузовых",
        field: "HeavyDutyTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество тяжёлых грузовых =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество тяжёлых грузовых автопоездов",
        pdfHeader: "Количество тяжёлых грузовых автопоездов",
        field: "HeavyDutyTruckRoadTrain",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество тяжёлых грузовых автопоездов =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество сверхтяжёлых грузовых",
        pdfHeader: "Количество сверхтяжёлых грузовых",
        field: "SuperHeavyDutyTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество сверхтяжёлых грузовых =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Количество сверхтяжёлых грузовых автопоездов",
        pdfHeader: "Количество сверхтяжёлых грузовых автопоездов",
        field: "SuperHeavyDutyTruckRoadTrain",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Количество сверхтяжёлых грузовых автопоездов =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Прирост интенсивности, %",
        pdfHeader: "Прирост интенсивности, %",
        field: "RateOfIntensity",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Прирост интенсивности, % =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Актуально с, км",
        pdfHeader: "Актуально с, км",
        field: "RelevantFrom",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Актуально с, км =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Актуально по, км",
        pdfHeader: "Актуально по, км",
        field: "RelevantTo",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Актуально по, км =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

export const RoadMeasuresTrafficIntensityGostColumns: any = [
    {
        headerName: "Общая интенсивность",
        pdfHeader: "Общая интенсивность",
        field: "TotalIntensity",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Общая интенсивность =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Легковые автомобили, небольшие грузовики (фургоны) и другие автомобили с прицепом и без него",
        pdfHeader: "Легковые автомобили, небольшие грузовики (фургоны) и другие автомобили с прицепом и без него",
        field: "CarLightTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Легковые автомобили, небольшие грузовики (фургоны) и другие автомобили с прицепом и без него =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Двухосные грузовые автомобили",
        pdfHeader: "Двухосные грузовые автомобили",
        field: "TwoAxleTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Двухосные грузовые автомобили =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Трёхосные грузовые автомобили",
        pdfHeader: "Трёхосные грузовые автомобили",
        field: "ThreeAxleTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Трёхосные грузовые автомобили =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Четырёхосные грузовые автомобили",
        pdfHeader: "Четырёхосные грузовые автомобили",
        field: "FourAxleTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Четырёхосные грузовые автомобили =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Четырехосные автопоезда (двухосный грузовой автомобиль с прицепом)",
        pdfHeader: "Четырехосные автопоезда (двухосный грузовой автомобиль с прицепом)",
        field: "FourAxleRoadTrain",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Четырехосные автопоезда (двухосный грузовой автомобиль с прицепом) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Пятиосные автопоезда (трёхосный грузовой автомобиль с прицепом)",
        pdfHeader: "Пятиосные автопоезда (трёхосный грузовой автомобиль с прицепом)",
        field: "FiveAxleRoadTrain",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Пятиосные автопоезда (трёхосный грузовой автомобиль с прицепом) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Трёхосные седельные автопоезда (двухосный седельный тягач с полуприцепом)",
        pdfHeader: "Трёхосные седельные автопоезда (двухосный седельный тягач с полуприцепом)",
        field: "ThreeAxleSemiTrailerTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Трёхосные седельные автопоезда (двухосный седельный тягач с полуприцепом) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Четырёхосные седельные автопоезда (двухосный седельный тягач с полуприцепом)",
        pdfHeader: "Четырёхосные седельные автопоезда (двухосный седельный тягач с полуприцепом)",
        field: "FourAxleSemiTrailerTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Четырёхосные седельные автопоезда (двухосный седельный тягач с полуприцепом) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Пятиосные седельные автопоезда (двухосный седельный тягач с полуприцепом)",
        pdfHeader: "Пятиосные седельные автопоезда (двухосный седельный тягач с полуприцепом)",
        field: "FiveAxleSemiTrailerTruckWith2AxleTractor",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Пятиосные седельные автопоезда (двухосный седельный тягач с полуприцепом) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Пятиосные седельные автопоезда (трёхосный седельный тягач с полуприцепом)",
        pdfHeader: "Пятиосные седельные автопоезда (трёхосный седельный тягач с полуприцепом)",
        field: "FiveAxleSemiTrailerTruckWith3AxleTractor",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Пятиосные седельные автопоезда (трёхосный седельный тягач с полуприцепом) =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Шестиосные седельные автопоезда",
        pdfHeader: "Шестиосные седельные автопоезда",
        field: "SixAxleSemiTrailerTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Шестиосные седельные автопоезда =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Автомобили с семью и более осями, и другие",
        pdfHeader: "Автомобили с семью и более осями, и другие",
        field: "SevenAxleTruck",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Автомобили с семью и более осями, и другие =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Автобусы",
        pdfHeader: "Автобусы",
        field: "Bus",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Автобусы =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Актуально с, км",
        pdfHeader: "Актуально с, км",
        field: "RelevantFrom",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Актуально с, км =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Актуально по, км",
        pdfHeader: "Актуально по, км",
        field: "RelevantTo",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Актуально по, км =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Мотоциклы",
        pdfHeader: "Мотоциклы",
        field: "Motorcycle",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Мотоциклы =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
]

export const DefectSegmentGOSTColumns: any = [
    {
        headerName: "Км",
        pdfHeader: "Км",
        field: "Position",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Начало, км  =",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Км+",
        pdfHeader: "Км+",
        field: "MaintenancePosition",
        valueType: "int",
        canBeFiltered: false,
        filterType: "equals",
        filterPlaceholder: "Км+  =",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Км",
        pdfHeader: "Км",
        field: "Ending",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Начало, км  =",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Км+",
        pdfHeader: "Км+",
        field: "MaintenanceEnding",
        valueType: "int",
        canBeFiltered: false,
        filterType: "equals",
        filterPlaceholder: "Км+  =",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Дефекты слева",
        pdfHeader: "Дефекты слева",
        field: "LeftDefectsStr",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Дефекты слева =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
    {
        headerName: "Дефекты справа",
        pdfHeader: "Дефекты справа",
        field: "RightDefectsStr",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Дефекты справа =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    },
]

export const DefectSegmentODMColumns: any = [
    {
        headerName: "Км",
        pdfHeader: "Начало, км",
        field: "Position",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Начало, км  =",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Км+",
        pdfHeader: "Начало, км+",
        field: "MaintenancePosition",
        valueType: "int",
        canBeFiltered: false,
        filterType: "equals",
        filterPlaceholder: "Км+  =",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Км",
        pdfHeader: "Конец, км",
        field: "Ending",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Начало, км  =",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Км+",
        pdfHeader: "Конец, км+",
        field: "MaintenanceEnding",
        valueType: "int",
        canBeFiltered: false,
        filterType: "equals",
        filterPlaceholder: "Км+  =",
        canBeSorted: false,
        showFilterMenu: true,
        width: 100,
        align: "left"
    },
    {
        headerName: "Оценка в баллах",
        pdfHeader: "Оценка в баллах",
        field: "Rating",
        valueType: "float",
        canBeFiltered: true,
        filterType: "equals",
        filterPlaceholder: "Оценка в баллах =",
        canBeSorted: true,
        showFilterMenu: true,
        width: 200,
        align: "left"
    }
]

export const RoadMeasureTypeToColumns: any = {
    RoadMeasuresProfile: RoadMeasuresProfileColumns,
    RoadMeasuresLongitudinalSlopes: RoadMeasuresLongitudinalSlopesColumns,
    RoadMeasuresCurveRadius: RoadMeasuresCurveRadiusColumns,
    RoadMeasuresVisibility: RoadMeasuresVisibilityColumns,
    RoadMeasuresLightings: RoadMeasuresLightingsColumns,
    RoadMeasuresRoadbedComplexs: RoadMeasuresRoadbedComplexsColumns,
    RoadMeasureRoadbeds: RoadMeasureRoadbedsColumns,
    RoadMeasuresAutomaticTrafficIntensity: RoadMeasuresAutomaticTrafficIntensityColumns,
    RoadMeasuresDurtyingWidth: RoadMeasuresDurtyingWidthColumns,
    RoadMeasuresElevation: RoadMeasuresElevationColumns,
    RoadMeasuresScan: RoadMeasuresScanColumns,
    RoadMeasuresTrafficIntensity: RoadMeasuresTrafficIntensityColumns,
    RoadMeasuresTransportTrafficIntensity: RoadMeasuresTrafficIntensityColumns,
    RoadMeasuresTrafficIntensityGost: RoadMeasuresTrafficIntensityGostColumns,
    DefectSegmentODM: DefectSegmentODMColumns,
    DefectSegmentGOST: DefectSegmentGOSTColumns,
}
